import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { HiPrinter } from "react-icons/hi2";

import classes from "./Print.module.css";
import Receipt from "./Receipt";

const Print = () => {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <div>
      <div style={{ display: "none" }}>
        <Receipt ref={componentRef} />
      </div>
      <button type="button" className={classes.button} onClick={handlePrint}>
        <HiPrinter className={classes.btnIcon} aria-hidden />
        Print receipt
      </button>
    </div>
  );
};

export default Print;
